"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const BlockQuoteContainer = /*#__PURE__*/_styledComponents.default.blockquote.withConfig({
  displayName: "BlockQuote__BlockQuoteContainer",
  componentId: "components-web__sc-vals3u-0"
})(["margin:0;position:relative;padding-left:", ";padding-right:", ";padding-bottom:", ";padding-top:", ";&::before{content:'';left:0;top:0;position:absolute;height:100%;width:", ";background:", ";}"], _ref => {
  let {
    paddingLeft
  } = _ref;
  return `${paddingLeft}px`;
}, _ref2 => {
  let {
    paddingRight
  } = _ref2;
  return `${paddingRight}px`;
}, _ref3 => {
  let {
    paddingBottom
  } = _ref3;
  return `${paddingBottom}px`;
}, _ref4 => {
  let {
    paddingTop
  } = _ref4;
  return `${paddingTop}px`;
}, _ref5 => {
  let {
    width
  } = _ref5;
  return `${width}px`;
}, _ref6 => {
  let {
    backgroundGradient
  } = _ref6;
  return backgroundGradient && (0, _utils.transformGradient)(backgroundGradient);
});
const QuoteContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "BlockQuote__QuoteContainer",
  componentId: "components-web__sc-vals3u-1"
})(["margin-bottom:", ";"], _ref7 => {
  let {
    marginBottom
  } = _ref7;
  return `${marginBottom}px`;
});
const selectTitleHeadingTokens = themeTokens => ({
  fontSize: themeTokens.titleHeadingFontSize,
  fontName: themeTokens.titleHeadingFontName,
  fontWeight: themeTokens.titleHeadingFontWeight,
  lineHeight: themeTokens.titleHeadingLineHeight
});
const BlockQuote = /*#__PURE__*/_react.default.forwardRef((_ref8, ref) => {
  let {
    children,
    link,
    additionalInfo,
    linkHref,
    textStyle = 'large',
    LinkRouter,
    linkRouterProps,
    tokens,
    variant,
    ...rest
  } = _ref8;
  const viewport = (0, _componentsBase.useViewport)();
  const {
    themeOptions: {
      enableMediaQueryStyleSheet
    }
  } = (0, _componentsBase.useTheme)();
  const useTokens = enableMediaQueryStyleSheet ? _componentsBase.useResponsiveThemeTokens : _componentsBase.useThemeTokens;
  const resolvedTokens = useTokens('BlockQuote', tokens, variant, !enableMediaQueryStyleSheet && {
    viewport
  });
  const themeTokens = enableMediaQueryStyleSheet ? resolvedTokens[viewport] : resolvedTokens;
  const {
    color,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    marginBottom,
    width,
    backgroundGradient,
    titleHeadingFontSize,
    titleHeadingFontName,
    titleHeadingFontWeight,
    titleHeadingLineHeight,
    titleFontSize,
    titleFontName,
    titleFontWeight,
    titleLineHeight,
    linkFontSize,
    linkFontName,
    linkFontWeight,
    linkLineHeight
  } = themeTokens;
  let titleHeadingStyles;
  let titleHeadingMediaIds;
  if (enableMediaQueryStyleSheet) {
    const {
      transformedTitleHeadingThemeTokens
    } = Object.entries(themeTokens).reduce((acc, _ref9) => {
      let [vp, viewportTokens] = _ref9;
      acc.transformedTitleHeadingThemeTokens[vp] = {
        fontSize: viewportTokens.titleHeadingFontSize,
        fontName: viewportTokens.titleHeadingFontName,
        fontWeight: viewportTokens.titleHeadingFontWeight,
        lineHeight: viewportTokens.titleHeadingLineHeight
      };
      return acc;
    }, {
      transformedTitleHeadingThemeTokens: {}
    });
    const titleHeadingMediaQueryStyles = (0, _componentsBase.createMediaQueryStyles)(transformedTitleHeadingThemeTokens);
    const {
      ids,
      styles
    } = _componentsBase.StyleSheet.create({
      titleHeading: {
        ...selectTitleHeadingTokens(themeTokens),
        ...titleHeadingMediaQueryStyles
      }
    });
    titleHeadingStyles = styles.titleHeading;
    titleHeadingMediaIds = ids.titleHeading;
  } else {
    titleHeadingStyles = {
      fontSize: titleHeadingFontSize,
      fontName: titleHeadingFontName,
      fontWeight: titleHeadingFontWeight,
      lineHeight: titleHeadingLineHeight
    };
  }
  const mappedTextSize = textStyle === 'heading' ? 'h3' : textStyle;
  const titleTokens = textStyle === 'heading' ? titleHeadingStyles : {
    fontSize: titleFontSize,
    fontName: titleFontName,
    fontWeight: titleFontWeight,
    lineHeight: titleLineHeight
  };
  const renderLink = () => {
    if (linkHref) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Link, {
        href: linkHref,
        tokens: {
          blockFontSize: linkFontSize,
          blockFontName: linkFontName,
          blockFontWeight: linkFontWeight,
          blockLineHeight: linkLineHeight,
          color
        },
        variant: {
          alternative: true
        },
        LinkRouter: LinkRouter,
        linkRouterProps: linkRouterProps,
        children: link
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      tokens: {
        color,
        fontName: linkFontName,
        fontSize: linkFontSize,
        fontWeight: linkFontWeight,
        lineHeight: linkLineHeight
      },
      children: link
    });
  };
  const renderQuote = () => {
    const quote = /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      tokens: {
        color,
        ...titleTokens
      },
      media: titleHeadingMediaIds,
      variant: {
        size: mappedTextSize
      },
      children: children
    });
    if (additionalInfo || link) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(QuoteContainer, {
        marginBottom: marginBottom,
        children: quote
      });
    }
    return quote;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(BlockQuoteContainer, {
    ...selectProps(rest),
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    width: width,
    backgroundGradient: backgroundGradient,
    ref: ref,
    children: [renderQuote(), (additionalInfo || link) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_componentsBase.StackView, {
      space: 0,
      children: [link && renderLink(), additionalInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
        tokens: {
          color
        },
        variant: {
          size: 'small'
        },
        children: additionalInfo
      })]
    })]
  });
});
BlockQuote.displayName = 'BlockQuote';
BlockQuote.propTypes = {
  ...selectedSystemPropTypes,
  ..._componentsBase.withLinkRouter.propTypes,
  tokens: (0, _componentsBase.getTokensPropType)('BlockQuote'),
  variant: _propTypes.default.exact({
    alternative: _propTypes.default.bool,
    size: _propTypes.default.string
  }),
  /**
   * Children nodes that can be added
   */
  children: _propTypes.default.node.isRequired,
  /**
   * External source's identifier (e.g. author's name)
   */
  link: _propTypes.default.string,
  /**
   * External source's URL
   */
  linkHref: _propTypes.default.string,
  /**
   * To provide additional information about the source, rendered underneath `link`
   */
  additionalInfo: _propTypes.default.string,
  /**
   * Whether to render BlockQuote as a heading size of `h3` or large text size
   */
  textStyle: _propTypes.default.oneOf(['large', 'heading'])
};
var _default = exports.default = BlockQuote;